<template>
    <div class="text-center generic-error-container d-flex justify-content-center align-items-center flex-column">
        <span class="text-warning generic-error-icon">
            <font-awesome-icon :icon="{ prefix: 'fas', iconName: icon }"/>
        </span>
        <span class="generic-error-text font-weight-300">{{text}}</span>
        <span v-if="subtext" v-html="subtext" class="mt-2 font-weight-300"></span>
    </div>
</template>
<script>
export default {
  name: 'no-data-error',
  props: {
    text: {
      required: false,
      default: 'No data available based on these parameters'
    },
    subtext: {
      required: false,
      default: ''
    },
    icon: {
      required: false,
      default: 'exclamation-triangle'
    }
  }
}
</script>
<style>
    .generic-error-container{
        height:400px;
    }
</style>
